<template>
  <div class="page page-home">
    <div class="title"></div>
    <div class="btn" @click="$router.replace('/game')"></div>
    <div class="tips"></div>
  </div>
</template>

<script>
export default {
    name:'Home'
}
</script>

<style lang="scss" scoped>
.icon{
    background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/icon.png?445466');
    background-size: 20rem 20rem;
    background-repeat: no-repeat;
    position: absolute;
    animation-fill-mode: both;
}
.page-home{
    background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/1.jpg?4545455466');
    .title{
      @extend .icon;
      width: 3.77rem;
      height: 7.10rem;
      background-position:0rem -2.90rem; 
      left: 0.62rem;
      top: 3.9rem;
      pointer-events: none;
      animation-name: fadeInLeft;
      animation-duration:0.3s;
    }
    .btn{
      @extend .icon;
      width: 4.82rem;
      height: 1.6rem;
      background-position:0rem 0rem;
      left: 0.91rem;
      top: 11.20rem;
      z-index: 2;
      animation-name: bounceIn;
      animation-duration:0.4s;  
    }
    .tips{
      @extend .icon;
      width: 4.64rem;
      height: 0.42rem;
      background-position: 0rem -1.92rem;
      left: 0.8rem;
      top: 13.02rem;
      pointer-events: none;
      animation-name: fadeInUp;
      animation-duration:0.6s;
      animation-delay: 1.4s;
    }
}
</style>